(function () {
  var HOW_TO_ORDER_PARAM = 'mtg_how_to_order';
  var HOW_TO_ORDER_PENDING_KEY = 'mtg_open_how_to_order_pending';

  function readDarkMode() {
    try {
      return localStorage.getItem('darkMode') !== 'false';
    } catch (e) {
      return document.documentElement.classList.contains('dark-mode') || (document.body && document.body.classList.contains('dark-mode'));
    }
  }

  function updateUi(darkOn) {
    var toggle = document.getElementById('dark-mode-toggle'); var toggleH = document.getElementById('dark-mode-toggle-header');
    var indicator = document.getElementById('mode-indicator');

    if (toggle) toggle.checked = darkOn; if (toggleH) toggleH.checked = darkOn;
    if (indicator) indicator.textContent = darkOn ? 'Dark mode active' : 'Light mode active';
    try {
      if (typeof window.__mamategaUpdateAutoScheduleLabels === 'function') {
        window.__mamategaUpdateAutoScheduleLabels({
          autoDarkSchedule: !!window.__MAMATEGA_AUTO_DARK__,
          auto_dark_start_hour: window.__MAMATEGA_AUTO_DARK_START__,
          auto_dark_end_hour: window.__MAMATEGA_AUTO_DARK_END__
        });
      }
    } catch (e) {}
  }

  function applyDarkMode(darkOn) {
    try {
      localStorage.setItem('darkMode', darkOn ? 'true' : 'false');
      localStorage.setItem('darkModeEnabled', darkOn ? 'true' : 'false');
    } catch (e) {}

    if (window.__mamategaSyncStoreDarkFromLs) {
      window.__mamategaSyncStoreDarkFromLs();
    } else {
      document.documentElement.classList.toggle('dark-mode', darkOn);
      if (document.body) document.body.classList.toggle('dark-mode', darkOn);
    }

    document.documentElement.setAttribute('data-theme', darkOn ? 'dark' : 'light');
    updateUi(darkOn);
  }

  function syncFromStore() {
    updateUi(readDarkMode());
  }

  function shouldInterceptHowToOrderLink(rawHref) {
    if (!rawHref) return false;
    if (/[?&]mtg_how_to_order=1(?:&|$)/.test(rawHref)) return true;
    return /^\/?pages\/contact(?:-us)?\/?(?:\?.*)?$/i.test(rawHref);
  }

  function markHowToOrderPending() {
    try {
      sessionStorage.setItem(HOW_TO_ORDER_PENDING_KEY, '1');
    } catch (e) {}
  }

  function clearHowToOrderPending() {
    try {
      sessionStorage.removeItem(HOW_TO_ORDER_PENDING_KEY);
    } catch (e) {}
  }

  function tryOpenHowToOrder() {
    try {
      if (window.MamaTegaChatbot && typeof window.MamaTegaChatbot.openHowToOrder === 'function') {
        window.MamaTegaChatbot.openHowToOrder();
        clearHowToOrderPending();
        return true;
      }
    } catch (e) {}

    try {
      window.dispatchEvent(new CustomEvent('mamatega:open-how-to-order', { bubbles: true }));
      return false;
    } catch (e) {
      return false;
    }
  }

  function openHowToOrderWithRetry() {
    var attempts = 0;
    markHowToOrderPending();

    function tick() {
      attempts += 1;
      if (tryOpenHowToOrder()) return;
      if (attempts >= 40) return;
      window.setTimeout(tick, 150);
    }

    tick();
  }

  function maybeResumePendingHowToOrder() {
    try {
      if (sessionStorage.getItem(HOW_TO_ORDER_PENDING_KEY) !== '1') return;
    } catch (e) {
      return;
    }
    openHowToOrderWithRetry();
  }

  function interceptHowToOrderClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var explicitTrigger = target.closest('[data-mamatega-how-to-order], .js-mamatega-how-to-order');
    if (explicitTrigger) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      openHowToOrderWithRetry();
      return;
    }

    var link = target.closest('a[href]');
    if (!link) return;

    var rawHref = link.getAttribute('href') || '';
    if (!shouldInterceptHowToOrderLink(rawHref)) return;

    try {
      var absoluteUrl = new URL(rawHref, window.location.href);
      if (absoluteUrl.origin !== window.location.origin) return;
    } catch (e) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    openHowToOrderWithRetry();
  }

  document.addEventListener('change', function (event) {
    if (!event.target || (event.target.id !== 'dark-mode-toggle' && event.target.id !== 'dark-mode-toggle-header')) return;
    applyDarkMode(event.target.checked);
  });

  document.addEventListener('click', interceptHowToOrderClick, true);

  document.addEventListener('DOMContentLoaded', syncFromStore);
  document.addEventListener('turbo:load', syncFromStore);
  document.addEventListener('turbo:render', syncFromStore);
  document.addEventListener('DOMContentLoaded', maybeResumePendingHowToOrder);
  document.addEventListener('turbo:load', maybeResumePendingHowToOrder);
  document.addEventListener('turbo:render', maybeResumePendingHowToOrder);
  window.addEventListener('pageshow', syncFromStore);
  window.addEventListener('pageshow', maybeResumePendingHowToOrder);

  syncFromStore();
  maybeResumePendingHowToOrder();
})();

/* MTG_HOURS_ONE_AT_A_TIME */
(function () {
  function syncHours() {
    var root = document.querySelector('[id^="MamaGlassHeader-"]');
    if (!root) return;
    var items = root.querySelectorAll('.mgh-hours-item');
    if (!items.length) return;
    var active = -1;
    items.forEach(function (item, i) {
      if (item.classList.contains('is-active')) active = i;
    });
    if (active < 0) active = 0;
    items.forEach(function (item, i) {
      var on = i === active;
      item.classList.toggle('is-active', on);
      item.style.setProperty('display', on ? 'block' : 'none', 'important');
      item.style.setProperty('opacity', on ? '1' : '0', 'important');
      item.style.setProperty('visibility', on ? 'visible' : 'hidden', 'important');
    });
  }
  function boot() {
    syncHours();
    var root = document.querySelector('[id^="MamaGlassHeader-"]');
    if (!root || root.__mtgHoursObs) return;
    root.__mtgHoursObs = true;
    var obs = new MutationObserver(syncHours);
    obs.observe(root, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  setInterval(syncHours, 1000);
})();

/* MTG_BRANDS_SUB_INJECT */
(function(){
  if (document.getElementById('mtg-brands-sub-light-style')) return;
  var s=document.createElement('style');
  s.id='mtg-brands-sub-light-style';
  s.textContent='html:not(.dark-mode) .cfxw__brandsSub,body:not(.dark-mode) .cfxw__brandsSub,html:not(.dark-mode) [id^="CosmeticFlexWidget-"] .cfxw__brandsSub{color:#111111!important;-webkit-text-fill-color:#111111!important}.dark-mode .cfxw__brandsSub,html.dark-mode .cfxw__brandsSub,body.dark-mode .cfxw__brandsSub{color:rgba(255,255,255,.9)!important;-webkit-text-fill-color:rgba(255,255,255,.9)!important}';
  (document.head||document.documentElement).appendChild(s);
})();

;/* BUST_1786386863 */
